import React, { useEffect, useState } from 'react';
import './WinModal.css';

interface WinModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

const WinModal: React.FC<WinModalProps> = ({ isVisible, onDismiss }) => {
  const [confetti, setConfetti] = useState<{ id: number; left: number; delay: number; color: string }[]>([]);

  useEffect(() => {
    if (isVisible) {
      // Generate confetti particles
      const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#DDA0DD', '#FF69B4', '#00CED1'];
      const particles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 2,
        color: colors[Math.floor(Math.random() * colors.length)]
      }));
      setConfetti(particles);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="win-modal-overlay" onClick={onDismiss}>
      <div className="confetti-container">
        {confetti.map(particle => (
          <div
            key={particle.id}
            className="confetti"
            style={{
              left: `${particle.left}%`,
              animationDelay: `${particle.delay}s`,
              backgroundColor: particle.color
            }}
          />
        ))}
      </div>
      
      <div className="win-modal" onClick={(e) => e.stopPropagation()}>
        <div className="win-modal-content">
          <div className="trophy">🏆</div>
          <h1 className="win-title">Congratulations!</h1>
          <p className="win-message">You found all the words!</p>
          <div className="stars">
            <span className="star">⭐</span>
            <span className="star">⭐</span>
            <span className="star">⭐</span>
          </div>
          <p className="win-hint">Click anywhere to play again</p>
        </div>
      </div>
    </div>
  );
};

export default WinModal;
